module.exports = __webpack_public_path__ + "img/3.efd64e24.png";